// Validation schemas (yup) live in `./validation` — NOT here — so importers of the
// plain string constants below do not pull yup into their bundle graph.
// See memory: constants-barrel-yup-leak-fix.

// MobileNumber lives in a yup-free leaf module; re-exported here for back-compat
// so existing `@/constants` importers keep working unchanged.
export {MobileNumber} from './contact';
export const meetingLink = 'https://meetings.hubspot.com/debut-infotech/business-discussion';

export const careerFormLink = 'https://docs.google.com/forms/d/e/1FAIpQLSdYYBd5puAfgPZdNP-pmHhvShi75uTox2TurxsGiVb822NDkw/viewform';
